<template>
  <div class="n-card-wrap" :style="$attrs.style">
    <slot>
      <slot name="header">
        <div class="header" :style="{ height: calc(60, 'px') }" v-if="title">
          <span></span>
          <span class="title">{{ title }}</span>
          <span class="iconfont icon-close"></span>
        </div>
      </slot>
      <slot name="content"></slot>
    </slot>
  </div>
</template>

<script>
export default {
  inject: ['calc'],
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
.n-card-wrap {
  box-sizing: border-box;
  border: 1px solid #a68d51;
  border-radius: 6px;
  background: linear-gradient(#29220b 5%, #0d0b05 50%);
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      text-align: center;
    }
    .icon-close {
      cursor: pointer;
      text-align: right;
    }
    & > * {
      flex: 1;
    }
  }
}
</style>
